// extracted by mini-css-extract-plugin
module.exports = {"container":"_hX","service":"_hY","title":"_hZ","fullscreen":"_h0","inputs":"_h1","input":"_h2","buttons":"_h3","button":"_h4","label_error":"_h5"};